import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import SpecialOffer from '@business/offers/SpecialOffer';

export enum SpecialOfferContactFormEntryStatus
{
    NEW = 'NEW',
    READ = 'READ',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    SOLVED = 'SOLVED',

}

export class SpecialOfferContactFormEntryGeneratedEntityManager<B extends SpecialOfferContactFormEntryGenerated> extends EntityManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'SpecialOfferContactFormEntry',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'specialOffer', type: BusinessEntityFieldType.ForeignKey, isRequiredInput: true, inputName: 'specialOfferId', inputProperty: 'specialOffer.id', relatedManager: SpecialOffer.manager },
				{ name: 'checkInDate', type: BusinessEntityFieldType.Date },
				{ name: 'checkOutDate', type: BusinessEntityFieldType.Date },
				{ name: 'numberOfAdults', type: BusinessEntityFieldType.Integer },
				{ name: 'numberOfChildren', type: BusinessEntityFieldType.Integer },
				{ name: 'childrenAges', type: BusinessEntityFieldType.Json },
				{ name: 'numberOfRooms', type: BusinessEntityFieldType.Integer },
				{ name: 'createdAt', type: BusinessEntityFieldType.DateTime, isInput: false },
				{ name: 'name', type: BusinessEntityFieldType.VarChar },
				{ name: 'email', type: BusinessEntityFieldType.VarChar },
				{ name: 'phone', type: BusinessEntityFieldType.VarChar },
				{ name: 'subject', type: BusinessEntityFieldType.VarChar },
				{ name: 'message', type: BusinessEntityFieldType.Text },
				{ name: 'status', type: BusinessEntityFieldType.VarChar },
				{ name: 'language', type: BusinessEntityFieldType.VarChar },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'specialOfferContactFormEntries',
        });
    }

}
/**
 * Represents a contact form entry for a special offer with booking details.
 */
export class SpecialOfferContactFormEntryGenerated extends BusinessEntity
{
	/** The special offer that the contact form entry is related to */
	specialOffer!: SpecialOffer;
	/** The check-in date for the booking inquiry */
	checkInDate: string | null = null;
	/** The check-out date for the booking inquiry */
	checkOutDate: string | null = null;
	/** The number of adults for the booking inquiry */
	numberOfAdults: number | null = null;
	/** The number of children for the booking inquiry */
	numberOfChildren: number | null = null;
	/** Array of integers representing the age of each child at check-out date (ages 0-17) */
	childrenAges: any | null = null;
	/** The number of rooms for the booking inquiry */
	numberOfRooms: number | null = null;
	/** The date and time the contact form entry was created. */
	createdAt!: string;
	/** The name of the contact form entry. */
	name: string = '';
	/** The email address of the contact form entry. */
	email!: string;
	/** The phone number of the contact form entry. */
	phone: string = '';
	/** The subject of the contact form entry. */
	subject: string = '';
	/** The message of the contact form entry. */
	message!: string;
	/** The status of the contact form entry. */
	status!: SpecialOfferContactFormEntryStatus;
	/** 2 letter code (lowercase) for the language of the contact form entry. */
	language: string = '';

}

export default SpecialOfferContactFormEntryGenerated;